// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".related-results[data-v-6fbb1480]{flex:1;overflow:auto;padding:1rem;border-bottom:1px solid #d3d3d3}@media screen and (max-width:768px){.related-results .column[data-v-6fbb1480]{min-width:8em}}.no-data[data-v-6fbb1480]{display:flex;flex-grow:1;align-items:center;justify-content:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
